import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import { sortNumeric, selectFormat, sortDate } from "components/Utils/Utils.js";

class LeeUpcomingRenewalStats extends Component {
  componentDidMount() {
    this.props.childRef(this);
    this.props.passRefUpward(this.childRef);
  }

  renderTable(data) {
    const { title } = this.props;

    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "start_month",
        text: "Start Month",
        style: { width: "140px", minWidth: "140px" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortDate,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "renewal_month",
        text: "Renewal Month",
        style: { width: "140px", minWidth: "140px" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortDate,
      },
      {
        dataField: "initial_price",
        text: "Initial Price",
        style: { width: "100px", minWidth: "100px" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "renewal_offer",
        text: "Renewal Offer",
        style: { width: "120px", minWidth: "120px" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "up_for_renewal",
        text: "Renewal Offer",
        style: { width: "120px", minWidth: "120px" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "cohort_engage_lifetime",
        text: "Cohort Engage (Lifetime)",
        style: { width: "100px", minWidth: "100px" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "hyper_engaged",
        text: "Hyper Engaged",
        style: { width: "120px", minWidth: "120px" },
        formatExtraData: { type: "percentage" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0%"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "1x_week_readers",
        text: "1x Week Readers",
        style: { width: "140px", minWidth: "140px" },
        formatExtraData: { type: "percentage" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "disengaged",
        text: "Disengaged",
        style: { width: "140px", minWidth: "140px" },
        formatExtraData: { type: "percentage" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0%"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const defaultSorted = [
      {
        dataField: "start_month",
        order: "desc",
      },
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    // const { data } = this.props;

    // if (data.hasData === false) {
    //   return <Error minHeight={360} />;
    // }

    // data.data.forEach((d, i) => {
    //   d.id = i;
    //   d.title = d.title || d.brand_title;
    // });

    const data = [
      {
        start_month: "2021-11",
        renewal_month: "2022-06",
        initial_price: "$1.00",
        renewal_offer: "tbd",
        up_for_renewal: 100,
        cohort_engage_lifetime: "50%",
        "cohort_engage_last_30%": "48%",
        hyper_engaged: "15%",
        "1x_week_readers": "35%",
        disengaged: "50%",
      },
      {
        start_month: "2022-01",
        renewal_month: "2022-06",
        initial_price: "$1.00",
        renewal_offer: "tbd",
        up_for_renewal: 638,
        cohort_engage_lifetime: "60%",
        "cohort_engage_last_30%": "51%",
        hyper_engaged: "15%",
        "1x_week_readers": "35%",
        disengaged: "50%",
      },
      {
        start_month: "2022-02",
        renewal_month: "2022-06",
        initial_price: "$1.00",
        renewal_offer: "tbd",
        up_for_renewal: 800,
        cohort_engage_lifetime: "70%",
        "cohort_engage_last_30%": "56%",
        hyper_engaged: "15%",
        "1x_week_readers": "35%",
        disengaged: "50%",
      },
      {
        start_month: "2022-01",
        renewal_month: "2022-07",
        initial_price: "$1.00",
        renewal_offer: "tbd",
        up_for_renewal: 200,
        cohort_engage_lifetime: "61%",
        "cohort_engage_last_30%": "43%",
        hyper_engaged: "15%",
        "1x_week_readers": "35%",
        disengaged: "50%",
      },
      {
        start_month: "2022-02",
        renewal_month: "2022-07",
        initial_price: "$1.00",
        renewal_offer: "tbd",
        up_for_renewal: 1200,
        cohort_engage_lifetime: "45%",
        "cohort_engage_last_30%": "28%",
        hyper_engaged: "15%",
        "1x_week_readers": "35%",
        disengaged: "50%",
      },
      {
        start_month: "2022-03",
        renewal_month: "2022-07",
        initial_price: "$1.00",
        renewal_offer: "tbd",
        up_for_renewal: 400,
        cohort_engage_lifetime: "55%",
        "cohort_engage_last_30%": "36%",
        hyper_engaged: "15%",
        "1x_week_readers": "35%",
        disengaged: "50%",
      },
    ];

    return (
      <>
        {this.renderTable(data)}
        <h3 className="mb-5 mt-5 insight-archive__title">Insights Detected</h3>
        <div className="insights-wrapper">
          <div className="insight-archive__text mb-2 mt-1">
            <div className="insight-token insight-token">
              Your October Cohort of $1 Initial Offers had a 14.5% renewal rate
              last month, but the $49 Renewal Offer group renewed at 33%.
              LIfetime Engagement was flat between both groups, with Converters
              engaged at 51% and Churned Users engaged at 32%.
            </div>
          </div>
          -
          <div className="insight-archive__text mb-2 mt-1">
            <div className="insight-token insight-token">
              Your February Cohort of $1 Initial Offers has a 56% Lifetime
              Engagement Rate but only a 28% Engagement Rate last month. This is
              well below your recent average of 44%.
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default LeeUpcomingRenewalStats;
